import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconOptionKey: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"option-key"} maskId="square-filled-radius-0-stroke-1-IconOptionKey"><path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM7 9H9.70508L13.7051 16.25H17V15.25H14.2949L10.2949 8H7V9ZM14 8V9H17V8H14Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconOptionKey;
